export function drawer() {
  $('.js-hamburger, .js-drawer').click(function() {
      $('.js-hamburger').toggleClass('is-active');
      $('.js-drawer').toggleClass('is-active');
  });
}